import { render, staticRenderFns } from "./swap.vue?vue&type=template&id=9ce049d8&scoped=true&"
import script from "./swap.vue?vue&type=script&lang=js&"
export * from "./swap.vue?vue&type=script&lang=js&"
import style0 from "./swap.vue?vue&type=style&index=0&id=9ce049d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce049d8",
  null
  
)

export default component.exports